import pluralize from 'pluralize';

/* UTILITY FUNCTIONS */
export function pluralisedCount(identifier: string, count: number) {
  return `${count} ${pluralize(identifier, count)}`;
}
